import { useCallback, useEffect, useState } from 'react';
import ProfileAvatar from '.././components/common/Avatar/ProfileAvatar';
import SearchBar from '../components/VCCS/SearchBar';
import StudentTable from '../components/VCCS/StudentTable';
import TablePagination from '../components/Dashboard/TablePagination';
import ColumnSelectionModal from '../components/Dashboard/ColumnSelectionModal';
import PaymentModal from '../components/Dashboard/PaymentModal';
import InvoiceHistoryModal from '../components/Dashboard/InvoiceHistoryModal';
import { getAllColumns, PERMANENT_COLUMNS } from '../utils/constants';
import { getCurrentDate } from '../utils/dateUtils';
import { fetchStudentRecords, getCurrentEmployee, fetchAllStudentRecords } from '../services/studentServicesVCS';
import { processPayment } from '../services/invoiceService';
import { generateInvoicePDF } from '../services/pdfService';
import { downloadExcelFile, columnLabels } from '../utils/exportUtils';
import AdvancedSearchModal from '../components/Dashboard/AdvancedSearchModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';

import '../styles/Dashboard.css';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Coursecomdb = () => {
  // Basic state variables
  const [searchField, setSearchField] = useState('name');
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectAll, setSelectAll] = useState(false);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState(false);
  const [pendingFeesOverdue, setPendingFeesOverdue] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);



  // Advanced search states
  const [selectedFilters, setSelectedFilters] = useState({
    location: '',
    branch: '',
    courseType: '',
  });

  const [dateRange, setDateRange] = useState({
    fromDate: '',
    toDate: ''
  });

  const [dueToday, setDueToday] = useState(false);
  const [todaysAdmission, setTodaysAdmission] = useState(false);
  const [pendingFeesList, setPendingFeesList] = useState(false);

  const [filterOptions, setFilterOptions] = useState({
    locations: [],
    branches: [],
    courseTypes: ['CADD', 'Pumo Tech IT', 'Pumo Tech Automation', 'Monz Creative School'],
    allBranches: []
  });

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);

  // Selected items states
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedStudentForInvoices, setSelectedStudentForInvoices] = useState(null);
  const [studentInvoices, setStudentInvoices] = useState([]);

  // Column selection states
  const [tempSelectedColumns, setTempSelectedColumns] = useState([...PERMANENT_COLUMNS]);
  const [selectedColumns, setSelectedColumns] = useState([...PERMANENT_COLUMNS]);

  // Payment form state
  const [paymentData, setPaymentData] = useState({
    paymentAmount: "",
    modeOfPayment: "",
    referenceNo: "",
    bank: "",
    pendingFeesDate: "",
    pendingFeesDate2: "",
  });

  // Fetch data from API with pagination and search parameters
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      console.log("🔍 Fetching data with params:", {
        currentPage,
        itemsPerPage,
        search,
        searchField,
        selectedFilters,
        dueToday,
        todaysAdmission,
        dateRange,
        pendingFeesList,
        pendingFeesOverdue
      });

      const response = await fetchStudentRecords(
        currentPage,
        itemsPerPage,
        search,
        searchField,
        selectedFilters,
        dueToday,
        todaysAdmission,
        dateRange,
        pendingFeesList,
        pendingFeesOverdue
      );

      console.log("📊 FULL API Response:", response);
      console.log("📊 Response type:", typeof response);
      console.log("📊 Response keys:", Object.keys(response));

      // Check if completedStudents exists
      console.log("📋 completedStudents exists:", 'completedStudents' in response);
      console.log("📋 completedStudents value:", response.completedStudents);
      console.log("📋 completedStudents type:", typeof response.completedStudents);
      console.log("📋 completedStudents length:", response.completedStudents?.length);

      // Log each student record
      if (response.completedStudents && Array.isArray(response.completedStudents)) {
        response.completedStudents.forEach((student, index) => {
          console.log(`👨‍🎓 Student ${index + 1}:`, student);
          console.log(`👨‍🎓 Student ${index + 1} keys:`, Object.keys(student));
        });
      }

      console.log("📈 Total pages:", response.totalPages);
      console.log("🔢 Total students:", response.totalStudents);

      // Set the data
      const studentsData = response.completedStudents || [];
      console.log("💾 Setting data:", studentsData);

      setData(studentsData);
      setTotalPages(response.totalPages || 0);
      setTotalRecords(response.totalStudents || 0);

      // Additional check after setting data
      console.log("✅ Data set successfully, length:", studentsData.length);

    } catch (error) {
      console.error("❌ Error fetching data:", error);
      console.error("❌ Error stack:", error.stack);
      toast.error("Failed to fetch data. Please try again.");
      setData([]);
      setTotalPages(0);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, search, searchField, selectedFilters, dueToday, todaysAdmission, dateRange, pendingFeesList, pendingFeesOverdue]);

  const navigate = useNavigate();

  useEffect(() => {
     const token = localStorage.getItem('token');
  if (!token) {
    navigate('/login', { replace: true });
  }
  }, [navigate]);
  
  useEffect(() => {
    console.log("FilterOptions updated:", filterOptions);
  }, [filterOptions]);


  // Initial data load
  // Replace the existing useEffect that loads locations and fetches employee data
  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const data = await getCurrentEmployee();
        console.log("Employee data received:", data); // Debug log

        if (data) {
          setHasAccess(data.has_access ?? false);
          setIsAdmin(data.role === 'Super-Admin');

          // Set locations and branches from employee data
          const employeeLocations = data.location || [];
          const employeeBranches = data.branch || [];

          console.log("Employee locations:", employeeLocations); // Debug log
          console.log("Employee branches:", employeeBranches); // Debug log

          setFilterOptions(prev => ({
            ...prev,
            locations: employeeLocations,
            branches: employeeBranches, // Show all branches initially
            allBranches: employeeBranches // Store all employee branches
          }));
        }
      } catch (error) {
        console.error("Error fetching employee data:", error);
        setHasAccess(false);
      }
    };

    fetchEmployeeData();
  }, []);

  // Add this function to handle location changes in the AdvancedSearchModal
  const handleLocationChange = (location) => {
    console.log("Location changed to:", location); // Debug log
    console.log("Available branches:", filterOptions.allBranches); // Debug log

    if (location) {
      // For now, show all employee branches regardless of location
      // since the employee has access to these branches
      const availableBranches = filterOptions.allBranches || [];
      console.log("Setting branches to:", availableBranches); // Debug log

      setFilterOptions(prev => ({
        ...prev,
        branches: availableBranches
      }));
    } else {
      // If no location selected, still show all branches
      setFilterOptions(prev => ({
        ...prev,
        branches: filterOptions.allBranches || []
      }));
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Search handlers
  const handleFieldChange = (e) => {
    setSearchField(e.target.value);
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearch(searchTerm);
    setCurrentPage(1);
  };

  // Pagination handlers
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const submitPayment = async () => {
    try {
      if (!selectedStudent) {
        toast.error("No student selected");
        return;
      }

      if (!paymentData || !paymentData.paymentAmount) {
        toast.error("Payment amount is required");
        return;
      }

      if (!paymentData.modeOfPayment) {
        toast.error("Mode of payment is required");
        return;
      }

      if (paymentData.modeOfPayment !== 'Cash') {
        if (!paymentData.referenceNo) {
          toast.error("Reference number is required for non-Cash payments");
          return;
        }

        if (!paymentData.bank) {
          toast.error("Bank details are required for non-Cash payments");
          return;
        }
      }

      console.log("Submitting payment data:", JSON.stringify(paymentData));

      const receiptDetails = await generateInvoicePDF(selectedStudent, paymentData);
      const result = await processPayment(selectedStudent, paymentData, receiptDetails);

      setData(prevData =>
        prevData.map(student =>
          student.studentId === result.updatedStudent.studentId ? result.updatedStudent : student
        )
      );

      closePaymentModal();
      toast.success("Payment processed and invoice generated!");
    } catch (error) {
      console.error("Payment processing error:", error);
      toast.error(`Failed to process payment: ${error.message || "Unknown error"}`);
    }
  };

  // Modal handlers
  const openColumnModal = () => {
    setIsModalOpen(true);
    setTempSelectedColumns(selectedColumns);
  };

  const closeColumnModal = () => {
    setIsModalOpen(false);
  };

  const confirmColumnSelection = () => {
    setSelectedColumns(tempSelectedColumns);
    setIsModalOpen(false);
  };

  const cancelColumnSelection = () => {
    setTempSelectedColumns(selectedColumns);
    setIsModalOpen(false);
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setTempSelectedColumns(PERMANENT_COLUMNS);
    } else {
      setTempSelectedColumns(getAllColumns().map(column => column.key));
    }
    setSelectAll(!selectAll);
  };

  const toggleColumnSelection = (column) => {
    if (PERMANENT_COLUMNS.includes(column)) return;

    setTempSelectedColumns(prev =>
      prev.includes(column)
        ? prev.filter(col => col !== column)
        : [...prev, column]
    );
  };

  // Payment modal handlers
  const openPaymentModal = (student) => {
    setSelectedStudent(student);
    setPaymentData({
      paymentAmount: "",
      modeOfPayment: "",
      referenceNo: "",
      bank: "",
      paymentDate: getCurrentDate(), // Add this line
      pendingFeesDate: student.pendingFeesDate || getCurrentDate(),
      pendingFeesDate2: student.pendingFeesDate2 || getCurrentDate(),
      pendingFeesDate3: student.pendingFeesDate3 || getCurrentDate(), // Add this line
      pendingFeesDate4: student.pendingFeesDate4 || getCurrentDate()  // Add this line
    });
    setIsPaymentModalOpen(true);
  };

  const closePaymentModal = () => {
    setIsPaymentModalOpen(false);
    setSelectedStudent(null);
    setPaymentData({
      paymentAmount: "",
      modeOfPayment: "",
      referenceNo: "",
      bank: "",
      pendingFeesDate: "",
      pendingFeesDate2: "",
      pendingFeesDate3: "", // Add this line
      pendingFeesDate4: ""
    });
  };

  // Advanced search handlers
  const openAdvancedSearch = () => {
    setIsAdvancedSearchOpen(true);
  };

  const closeAdvancedSearch = () => {
    setIsAdvancedSearchOpen(false);
  };

  // Replace the existing handleAdvancedSearchApply function
  const handleAdvancedSearchApply = ({ filters, dateRange: newDateRange, quickFilters }) => {
    console.log("Applying advanced search with filters:", filters);

    // Update all filter states
    setSelectedFilters(filters);
    setDateRange(newDateRange);
    setDueToday(quickFilters.dueToday);
    setTodaysAdmission(quickFilters.todaysAdmission);
    setPendingFeesList(quickFilters.pendingFeesList);
    setPendingFeesOverdue(quickFilters.pendingFeesOverdue); // Add this line

    // Reset current page to 1
    setCurrentPage(1);

    // Clear regular search if any quick filter is applied
    if (quickFilters.dueToday || quickFilters.todaysAdmission || quickFilters.pendingFeesList || quickFilters.pendingFeesOverdue) {
      setSearch('');
    }

    // Show appropriate toast message
    const activeFilters = [];
    if (filters.location) activeFilters.push(`Location: ${filters.location}`);
    if (filters.branch) activeFilters.push(`Branch: ${filters.branch}`);
    if (filters.courseType) activeFilters.push(`Course: ${filters.courseType}`);
    if (newDateRange.fromDate && newDateRange.toDate) {
      activeFilters.push(`Date: ${newDateRange.fromDate} to ${newDateRange.toDate}`);
    }
    if (quickFilters.dueToday) activeFilters.push('Payments Due Today');
    if (quickFilters.todaysAdmission) activeFilters.push("Today's Admissions");
    if (quickFilters.pendingFeesList) activeFilters.push('Pending Fees');
    if (quickFilters.pendingFeesOverdue) activeFilters.push('Overdue Pending Fees'); // Add this line

    if (activeFilters.length > 0) {
      toast.info(`Applied filters: ${activeFilters.join(', ')}`);
    }
  };

  const handleAdvancedSearchClear = () => {
    // Clear all filters
    setSelectedFilters({
      location: '',
      branch: '',
      courseType: '',
    });
    setDateRange({
      fromDate: '',
      toDate: ''
    });
    setDueToday(false);
    setTodaysAdmission(false);
    setPendingFeesList(false);
    setPendingFeesOverdue(false); // Add this line
    setSearch('');
    setCurrentPage(1);

    toast.info("All filters cleared");
  };

  // Invoice handlers
  const openInvoiceModal = async (student) => {
    try {
      setSelectedStudentForInvoices(student);

      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication error. Please login again.");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/invoices?studentId=${student.studentId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.ok) {
        const data = await response.json();
        setStudentInvoices(data.invoices || []);
        setIsInvoiceModalOpen(true);
      } else {
        throw new Error("Failed to fetch invoices");
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
      toast.error("Failed to retrieve invoice history. Please try again.");
    }
  };

  const handleStudentUpdate = (updatedStudent) => {
    // Update the data state with the updated student info
    setData(prevData =>
      prevData.map(student =>
        (student.studentId === updatedStudent.studentId)
          ? updatedStudent
          : student
      )
    );
    toast.success("Student information updated successfully!");
  };

  const downloadAllData = async () => {
    try {
      setLoading(true);
      toast.info("Preparing data for download...");

      // Fetch all records with current filters applied
      const response = await fetchAllStudentRecords(
        search,
        searchField,
        selectedFilters,
        dueToday,
        todaysAdmission,
        dateRange,
        pendingFeesList,
        pendingFeesOverdue // Add this parameter
      );

      if (response.registrations && response.registrations.length > 0) {
        downloadExcelFile(response.registrations, selectedColumns, columnLabels);
        toast.success(`Downloaded ${response.registrations.length} records successfully!`);
      } else {
        toast.warning("No data available to download with current filters");
      }
    } catch (error) {
      console.error("Error downloading all data:", error);
      toast.error("Failed to download data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1 className="dashboard-heading">COURSE COMPLETED STUDENT RECORDS </h1>
        <button className="back-btn" onClick={() => navigate(-1)} title={`Previous page`}>
          ←
        </button>
        <div className="flex items-center gap-4">
          <ProfileAvatar />
        </div>
      </div>
      <div className="record-count-wrapper">
        <div className="record-count-card">
          <div className="card-content">
            <div className="text-section">
              <span className="label">STUDENT RECORDS COUNT </span>
              <h2 className="value">
                Viewing {data.length} of {totalRecords} records
              </h2>
            </div>
            <div className="icon-section">
              <FontAwesomeIcon icon={faUsers} />
            </div>
          </div>
        </div>
      </div>
      <div className='head'>
        <h3>Search student Details</h3>
      </div>

      {/* Active Filters Display */}
      {(dueToday || todaysAdmission || pendingFeesList || pendingFeesOverdue || (dateRange.fromDate && dateRange.toDate) || selectedFilters.location || selectedFilters.branch || selectedFilters.courseType) && (
        <div className="active-filters">
          <p>Active Filters:</p>
          {dueToday && (
            <span className="filter-badge">
              Payments Due Today
              <button onClick={() => setDueToday(false)} className="filter-remove">×</button>
            </span>
          )}
          {pendingFeesList && (
            <span className="filter-badge">
              Pending Fees List
              <button onClick={() => setPendingFeesList(false)} className="filter-remove">×</button>
            </span>
          )}
          {pendingFeesOverdue && (
            <span className="filter-badge">
              Overdue Pending Fees
              <button onClick={() => setPendingFeesOverdue(false)} className="filter-remove">×</button>
            </span>
          )}
          {todaysAdmission && (
            <span className="filter-badge">
              Today's Admissions
              <button onClick={() => setTodaysAdmission(false)} className="filter-remove">×</button>
            </span>
          )}
          {(dateRange.fromDate && dateRange.toDate) && (
            <span className="filter-badge">
              Admissions: {dateRange.fromDate} to {dateRange.toDate}
              <button onClick={() => setDateRange({ fromDate: '', toDate: '' })} className="filter-remove">×</button>
            </span>
          )}
          {selectedFilters.location && (
            <span className="filter-badge">
              Location: {selectedFilters.location}
              <button onClick={() => setSelectedFilters(prev => ({ ...prev, location: '' }))} className="filter-remove">×</button>
            </span>
          )}
          {selectedFilters.branch && (
            <span className="filter-badge">
              Branch: {selectedFilters.branch}
              <button onClick={() => setSelectedFilters(prev => ({ ...prev, branch: '' }))} className="filter-remove">×</button>
            </span>
          )}
          {selectedFilters.courseType && (
            <span className="filter-badge">
              Course Type: {selectedFilters.courseType}
              <button onClick={() => setSelectedFilters(prev => ({ ...prev, courseType: '' }))} className="filter-remove">×</button>
            </span>
          )}
          <button onClick={handleAdvancedSearchClear} className="clear-all-filters">Clear All</button>
        </div>
      )}

      <SearchBar
        searchField={searchField}
        search={search}
        handleFieldChange={handleFieldChange}
        handleSearch={handleSearch}
        selectedColumns={selectedColumns}
        hasAccess={hasAccess}
        openAdvancedSearch={openAdvancedSearch}
      />
      {isAdvancedSearchOpen && (
        <AdvancedSearchModal
          isOpen={isAdvancedSearchOpen}
          closeModal={closeAdvancedSearch}
          filterOptions={filterOptions}
          selectedFilters={selectedFilters}
          dateRange={dateRange}
          dueToday={dueToday}
          todaysAdmission={todaysAdmission}
          pendingFeesList={pendingFeesList}
          pendingFeesOverdue={pendingFeesOverdue} // Add this prop
          onApply={handleAdvancedSearchApply}
          onClear={handleAdvancedSearchClear}
          onLocationChange={handleLocationChange}
        />
      )}

      <StudentTable
        data={data}
        loading={loading}
        selectedColumns={selectedColumns}
        getAllColumns={getAllColumns}
        openPaymentModal={openPaymentModal}
        openInvoiceModal={openInvoiceModal}
        hasAccess={hasAccess}
        onStudentUpdate={handleStudentUpdate}
      />

      <TablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        paginate={paginate}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        setCurrentPage={setCurrentPage}
        openColumnModal={openColumnModal}
        downloadExcel={downloadAllData}
        data={data}
        totalRecords={totalRecords} // Add this prop
        recordsOnCurrentPage={data.length}
      />

      {isModalOpen && (
        <ColumnSelectionModal
          isOpen={isModalOpen}
          closeModal={closeColumnModal}
          tempSelectedColumns={tempSelectedColumns}
          toggleColumnSelection={toggleColumnSelection}
          permanentColumns={PERMANENT_COLUMNS}
          allColumns={getAllColumns()}
          selectAll={selectAll}
          toggleSelectAll={toggleSelectAll}
          confirmSelection={confirmColumnSelection}
          cancelSelection={cancelColumnSelection}
        />
      )}

      {isPaymentModalOpen && selectedStudent && (
        <PaymentModal
          isOpen={isPaymentModalOpen}
          closeModal={closePaymentModal}
          student={selectedStudent}
          paymentData={paymentData}
          setPaymentData={setPaymentData}
          onSubmit={submitPayment}
          setData={setData}
        />
      )}

      {isInvoiceModalOpen && selectedStudentForInvoices && (
        <InvoiceHistoryModal
          isOpen={isInvoiceModalOpen}
          closeModal={() => setIsInvoiceModalOpen(false)}
          student={selectedStudentForInvoices}
          invoices={studentInvoices}
        />
      )}
    </div>
  );
};

export default Coursecomdb;